import { render, staticRenderFns } from "./Clinic.vue?vue&type=template&id=27e2a512&scoped=true&"
import script from "./Clinic.vue?vue&type=script&lang=js&"
export * from "./Clinic.vue?vue&type=script&lang=js&"
import style1 from "./Clinic.vue?vue&type=style&index=1&id=27e2a512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e2a512",
  null
  
)

export default component.exports